const GEO_REDIRECT_SNOOZE_KEY = 'geo-redirect:snoozed-until';
const GEO_REDIRECT_SNOOZE_DAYS = 14;
const GEO_REDIRECT_COUNTRY_KEY = 'geo-redirect:country';

/**
 * @typedef {{ detected_values?: { country?: { handle?: string } } }} BrowsingContextSuggestions
 */

/**
 * @param {BrowsingContextSuggestions | null | undefined} suggestions
 * @returns {string | null}
 */
function geoRedirectDetectedCountry(suggestions) {
  const handle = suggestions?.detected_values?.country?.handle;
  return typeof handle === 'string' ? handle : null;
}

/**
 * @param {string | null} snoozedUntil
 * @param {number} now
 * @returns {boolean}
 */
function geoRedirectIsSnoozed(snoozedUntil, now) {
  return Number(snoozedUntil) > now;
}

/**
 * @param {number} now
 * @returns {string}
 */
function geoRedirectSnoozeUntil(now) {
  return String(now + GEO_REDIRECT_SNOOZE_DAYS * 24 * 60 * 60 * 1000);
}

/** @returns {Promise<string | null>} */
async function geoRedirectFetchCountry() {
  const cached = sessionStorage.getItem(GEO_REDIRECT_COUNTRY_KEY);
  if (cached) return cached;
  const root = window.Shopify?.routes?.root || '/';
  const response = await fetch(`${root}browsing_context_suggestions.json?country[enabled]=true`);
  if (!response.ok) throw new Error(`browsing_context_suggestions ${response.status}`);
  const country = geoRedirectDetectedCountry(await response.json());
  if (country) sessionStorage.setItem(GEO_REDIRECT_COUNTRY_KEY, country);
  return country;
}

/** @param {HTMLElement} modal */
async function geoRedirectInit(modal) {
  try {
    const isSnoozed = () => geoRedirectIsSnoozed(localStorage.getItem(GEO_REDIRECT_SNOOZE_KEY), Date.now());
    if (isSnoozed()) return;
    const country = await geoRedirectFetchCountry();
    if (country !== modal.dataset.geoRedirectCountry || isSnoozed()) return;
    if (getComputedStyle(document.body).overflow === 'hidden') return;
    localStorage.setItem(GEO_REDIRECT_SNOOZE_KEY, geoRedirectSnoozeUntil(Date.now()));
    /** @type {HTMLElement & { open(): void }} */ (modal).open();
  } catch {}
}

if (typeof document !== 'undefined') {
  const geoRedirectModal = document.getElementById('GeoRedirectModal');
  if (geoRedirectModal) geoRedirectInit(geoRedirectModal);
}
